import { configureStore, createSlice } from '@reduxjs/toolkit'

let login = createSlice({
    name: 'login',
    initialState: { value: false },
    reducers: {
        checkLogin(state, action) {
            state.value = action.payload
        }
    }
})

let Darkmode = createSlice({
    name: 'Darkmode',
    initialState: { value: false },
    reducers: {
        checkMode(state, action) {
            const objString = localStorage.getItem('token');
            if (objString != null) {
                const obj = JSON.parse(objString);
                const newobj = {
                    value: obj.value,
                    expire: obj.expire,
                    mode: action.payload ? "dark" : "light",
                }
                const newobjString = JSON.stringify(newobj);
                localStorage.setItem('token', newobjString)
            }
            state.value = action.payload
        }
    }
})

let HeaderTitle = createSlice({
    name: 'HeaderTitle',
    initialState: {
        mainTitle: "",
        subTitle: ""
    },
    reducers: {
        changeHeaderTitle(state, action) {
            return action.payload
        }
    }
})

let Current_Location = createSlice({
    name: 'Current_Location',
    initialState: { value: "" },
    reducers: {
        change_Current_Location(state, action) {
            state.value = action.payload
        }
    }
})

let Favorite = createSlice({
    name: 'Favorite',
    initialState: JSON.parse(localStorage.getItem('favorite_menu')) ??
        [
            { name: "대시보드", state: 0, link: "dashboard" },
            { name: "거래내역", state: 0, link: "paylist" },
            { name: "거래보류내역", state: 0, link: "setoffPaylist" },
            { name: "정산달력", state: 0, link: "calendar" },
            { name: "가맹점 정산내역", state: 0, link: "settlements" },
            { name: "에이전트 정산내역", state: 0, link: "settlementsAgent" },
            { name: "상계내역", state: 0, link: "setoffSettlements" },
            { name: "무실적가맹점", state: 0, link: "unsoldMerchant" },
            // { name: "거래별 정산이력", state: 0, link: "payDetailList" },
            // { name: "정산이력", state: 0, link: "settlementHis" },
            // { name: "업체등록", state: 0, link: "excelData" },
            { name: "지사", state: 0, link: "distributor" },
            { name: "총판", state: 0, link: "agency" },
            { name: "대리점", state: 0, link: "franchise" },
            { name: "가맹점", state: 0, link: "submerchants" },
            { name: "관리자조회", state: 0, link: "admin" },
            // { name: "공지사항", state: 0, link: "board" },
            // { name: "단말기 관리", state: 0, link: "product" },
            { name: "즐겨찾기 관리", state: 0, link: "favorite" }
        ],
    reducers: {
        change_Favorite(state, action) {
            localStorage.setItem('favorite_menu', JSON.stringify(action.payload));
            return action.payload
        }
    }
});

let MyData = createSlice({
    name: 'MyData',
    initialState: JSON.parse(localStorage.getItem('user')) ?? [],
    reducers: {
        change_MyData(state, action) {
            localStorage.setItem('user', JSON.stringify(action.payload))
            return action.payload
        }
    }
})

let total_search = createSlice({
    name: 'total_search',
    initialState: { value: "" },
    reducers: {
        change_Total_Search(state, action) {
            state.value = action.payload
        }
    }
})

let anthScreen = createSlice({
    name: 'anthScreen',
    initialState: [],
    reducers: {
        check_anthScreen(state, action) {
            return action.payload
        }
    }
})

let hostLogoImg = createSlice({
    name: 'hostLogoImg',
    initialState: { value: "fast" },
    reducers: {
        change_hostLogoImg(state, action) {
            state.value = action.payload
        }
    }
})

let pgChoose = createSlice({
    name: 'pgChoose',
    initialState: { value: "" },
    reducers: {
        change_pgChoose(state, action) {
            state.value = action.payload
        }
    }
})


export let { checkLogin } = login.actions
export let { checkMode } = Darkmode.actions
export let { changeHeaderTitle } = HeaderTitle.actions
export let { change_Current_Location } = Current_Location.actions
export let { change_Favorite } = Favorite.actions
export let { change_MyData } = MyData.actions
export let { change_Total_Search } = total_search.actions
export let { check_anthScreen } = anthScreen.actions
export let { change_hostLogoImg } = hostLogoImg.actions
export let { change_pgChoose } = pgChoose.actions

export default configureStore({
    reducer: {
        login: login.reducer,
        Darkmode: Darkmode.reducer,
        HeaderTitle: HeaderTitle.reducer,
        Current_Location: Current_Location.reducer,
        Favorite: Favorite.reducer,
        MyData: MyData.reducer,
        total_search: total_search.reducer,
        anthScreen: anthScreen.reducer,
        hostLogoImg: hostLogoImg.reducer,
        pgChoose: pgChoose.reducer,
    }
}) 